import * as React from "react";
import { Container, Icon, Text } from "@jds/core";
import "./ImageCropper.css";

import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  makeAspectCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

//MUI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import setCanvasPreview from "./setCanvasPreview";

//box style
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  //   height: "300px",
  height: "auto",
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: "24px",
  boxShadow: 24,
  p: 4,
};
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const MIN_DIMENSION = 50;
const ASPECT_RATIO = 1;

export default function ImageCropper() {
  const [open, setOpen] = React.useState(false);
  const [crop, setCrop] = React.useState();
  const imgRef = React.useRef(null);
  const canvasRef = React.useRef(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [imgSrc, setImgSrc] = React.useState("");
  const [imgBlob, setImgBlob] = React.useState();
  const handleSelectFile = (e) => {
    console.log(e);
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    console.log("here");
    reader.addEventListener("load", () => {
      const imageUrl = reader.result?.toString() || "";
      // console.log(imageUrl);
      setImgSrc(imageUrl);
    });
    reader.readAsDataURL(file);
  };

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const crop = makeAspectCrop(
      {
        unit: "%",
        width: 25,
      },
      ASPECT_RATIO,
      width,
      height
    );
    const centeredCrop = centerCrop(crop, width, height);
    setCrop(centeredCrop);
  };
  function dataURLToBlob(dataURL) {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }

  return (
    <div>
      <Button onClick={handleOpen}>Open modal</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <Text
                text="Change your photo"
                color="black"
                appearance="heading_xs"
              />
              <Text
                text="This will be shown on your profile."
                color="primary-grey-80"
                appearance="body_xs_bold"
              />
            </div>
            <Icon
              ic={"IcClose"}
              color="primary_grey_80"
              size="large"
              onClick={() => {
                setOpen(false);
                setImgSrc("");
              }}
            />
          </div>
          {/* <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
          >
            Upload files
            <VisuallyHiddenInput
              type="file"
              onChange={(e) => handleSelectFile(e)}
              multiple
            />
          </Button> */}
          {imgSrc === "" && (
            <div
              className="upload-dialog"
              onClick={() => document.getElementById("file-input").click()}
            >
              <VisuallyHiddenInput
                id="file-input"
                type="file"
                onChange={(e) => handleSelectFile(e)}
                multiple
              />
              <Icon ic={"IcCloudUpload"} size="large" color="primary_grey_80" />
              <Text
                text="Click to upload"
                color="primary-60"
                appearance="body_s_bold"
              />
              <Text
                text="Use a square image for best results"
                color="primary-grey-80"
                appearance="body_xs"
              />
            </div>
          )}
          {imgSrc && (
            <div
              style={{
                marginTop: "5px auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <ReactCrop
                crop={crop}
                circularCrop
                keepSelection
                aspect={ASPECT_RATIO}
                minWidth={MIN_DIMENSION}
                onChange={(pixelCrop, percentCrop) => {
                  setCrop(percentCrop);
                }}
              >
                <img
                  src={imgSrc}
                  style={{
                    maxHeight: "55vh",
                  }}
                  onLoad={onImageLoad}
                  ref={imgRef}
                />
              </ReactCrop>
              {/* <Button
                onClick={() => {
                  setCanvasPreview(
                    imgRef.current,
                    canvasRef.current,
                    convertToPixelCrop(
                      crop,
                      imgRef.current.width,
                      imgRef.current.height
                    )
                  );
                  const dataUrl = canvasRef.current.toDataURL();
                  const croppedImg = dataURLToBlob(dataUrl);
                  const imageUrl = URL.createObjectURL(croppedImg);
                }}
              >
                Crop
              </Button> */}
              {crop && (
                <canvas
                  ref={canvasRef}
                  style={{
                    display: "none",
                    objectFit: "contain",
                    width: 150,
                    height: 150,
                  }}
                ></canvas>
              )}
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "3%",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
                setImgSrc("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={imgSrc.length === 0}
              onClick={() => {
                try {
                  setCanvasPreview(
                    imgRef.current,
                    canvasRef.current,
                    convertToPixelCrop(
                      crop,
                      imgRef.current.width,
                      imgRef.current.height
                    )
                  );
                  const dataUrl = canvasRef.current.toDataURL();
                  const croppedImg = dataURLToBlob(dataUrl);
                  console.log(dataURLToBlob(dataUrl));
                  console.log("hello");
                  const imageURL = URL.createObjectURL(croppedImg);
                  setImgBlob(imageURL);
                  console.log("hello123", imageURL);
                  // setOpen(false);
                } catch (error) {
                  console.log(error);
                }
              }}
            >
              Save Changes
            </Button>
            <p>hell</p>
            <img src={imgBlob} />
          </div>
        </Box>
      </Modal>
    </div>
  );
}
